import { JOB_OFFER_CONTEXT } from '@hublo/enums/recruitment/job-offer-context.enum'

const DEFAULT_REFERER = 'career_site'

type JobApplyOffer = {
  uuid?: string | null
  sourceUuid?: string | null
  context?: string | null
}

export type JobAdSearch = {
  referer?: string
}

export const parseJobAdSearch = (
  search: Record<string, unknown>,
): JobAdSearch => ({
  referer: typeof search.referer === 'string' ? search.referer : undefined,
})

export const buildJobApplyRoute = (
  offer: JobApplyOffer | undefined,
  referer: string | undefined,
): string => {
  const query = new URLSearchParams({ referer: referer || DEFAULT_REFERER })

  return offer?.context === JOB_OFFER_CONTEXT.REPLACEMENT
    ? `/front/worker/job-offers/${offer.uuid ?? ''}?${query}`
    : `/front/worker/job-offers/${offer?.sourceUuid ?? ''}/job-apply/presentation?${query}`
}
